import { css } from 'emotion';

const styles = {
	paginator: css`
		> div {
			margin-right: 0px;
		}
	`,
};

export { styles };
